import Swal, { SweetAlertIcon } from 'sweetalert2';

// const navigate = useNavigate();

export function swal(
  icon: SweetAlertIcon,
  title: string,
  html: string,
  time = 2500,
  width = '30vw',
): void {
  Swal.fire({
    icon: icon,
    title: title,
    html: html,
    timer: time,
    timerProgressBar: true,
    showConfirmButton: false,
    width: width,
  });
}

export function swalHtml(
  icon: SweetAlertIcon,
  title: string,
  html: HTMLElement,
): void {
  Swal.fire({
    icon: icon,
    title: title,
    html: html,
    timer: 3000,
    timerProgressBar: true,
  });
}

export function swalDelete() {
  return new Promise((resolve) => {
    Swal.fire({
      icon: 'warning',
      title: 'Excluir Registro?',
      html: '<span style="font-size: 1.45rem;">Tem certeza que deseja <b>excluir</b> o registro?</span>',
      confirmButtonColor: '#d33',
      confirmButtonText: 'Excluir!',
      cancelButtonColor: '#3085d6',
      cancelButtonText: 'Cancelar',
      showCancelButton: true,
    }).then((result) => {
      resolve(result.isConfirmed); // Resolva a promessa com true se confirmado, false caso contrário
    });
  });
}

export function swalSave() {
  Swal.fire({
    icon: 'success',
    title: 'Registro Criado com Sucesso!',
    html: '<span style="font-size: 1.45rem;">Novo registro criado!</span>',
    timer: 2500,
    timerProgressBar: true,
    showConfirmButton: false,
  });
}

interface SwalDeleteConfirmOptions {
  title?: string;
  html?: string;
}

export function swalDeleteConfirm({
  title = 'Registro Deletado!',
  html = '<span style="font-size: 1.45rem;">Registro <b>deletado</b> com sucesso!</span>',
}: SwalDeleteConfirmOptions = {}) {
  Swal.fire({
    icon: 'warning',
    title,
    html,
    timer: 2500,
    timerProgressBar: true,
    showConfirmButton: false,
  });
}

export function swalCadastro() {
  Swal.fire({
    icon: 'success',
    title: 'Sucesso',
    text: 'Solicitação de cadastro concluída com sucesso. Seu acesso será liberado após avaliação',
    confirmButtonText: 'Entendi!',
    confirmButtonColor: '#0B182C',
  }).then((result) => {
    if (result.isConfirmed) {
      Swal.fire({
        icon: 'info',
        title: 'Aguarde',
        text: 'Redirecionando para a página de login...',
        timer: 2000,
        timerProgressBar: true,
        showConfirmButton: false,
      });
      setTimeout(() => {
        window.location.href = '/';
      }, 1500);
    }
  });
}

export function swalAtualizacao(title: string, text: string) {
  Swal.fire({
    icon: 'success',
    title: title,
    html: '<span style="font-size: 1.45rem;">' + text + '</span>',
    timer: 2500,
    timerProgressBar: true,
    showConfirmButton: false,
  });
  // setTimeout(() => {
  //   window.location.reload();
  // }, 2500);
}

export function swalErro(text: string) {
  Swal.fire({
    icon: 'error',
    title: 'Erro!',
    html: '<span style="font-size: 1.45rem;">' + text + '</span>',
    showConfirmButton: true,
    confirmButtonColor: '#d33',
    width: '30%',
  });
}

export function swalAttention(text: string) {
  Swal.fire({
    icon: 'warning',
    title: 'Atenção!',
    html: '<span style="font-size: 1.45rem;">' + text + '</span>',
    showConfirmButton: true,
    confirmButtonColor: 'orangered',
    width: '30%',
  });
}
